import { inject } from "@angular/core";
import { AuthService } from "./auth.service";
import { CanActivateFn } from "@angular/router";

/**
 * Simple functional guard maiking use of the AuthService
 * Used to separate the guard from the auth processing
 */
export const authGuard: CanActivateFn = () => inject(AuthService).isAuthenticated();
